export default {
  title: 'Win/Loss Report',
  backButton: 'Back to all reports',
  adminBackButton: 'Back to MBD Reports',
};
